module.exports = __webpack_public_path__ + "assets/img/4b9194e0ed6e28a1ac635867e49f1917.png";